import { render, staticRenderFns } from "./aggregator-games-list.vue?vue&type=template&id=07647b50&scoped=true"
import script from "./aggregator-games-list.vue?vue&type=script&lang=js"
export * from "./aggregator-games-list.vue?vue&type=script&lang=js"
import style0 from "./aggregator-games-list.vue?vue&type=style&index=0&id=07647b50&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07647b50",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/aggregator-games-list.vue
// module id = gLVT
// module chunks = 0